'use client';
import IdentityAcls from '@nerdwallet/identity-acls';
import { useQueryWithLog } from '@lib/hooks/logging-hooks';
import { ApolloError, gql } from '@nerdwallet/apollo';
import { MockedResponse } from '@nerdwallet/apollo/testing';

import { getLogger } from '@lib/logging';

const logger = getLogger('useIsNerdWalletPlusMember');

export const NERDWALLET_PLUS_MEMBERSHIP_QUERY = gql`
  query GetIsNerdWalletPlusMember {
    identity {
      id
      isNerdWalletPlusMember
      roles
    }
  }
`;

export const useIsNerdWalletPlusMember = (
  skipQuery = false,
): {
  isNerdWalletPlusMember: boolean;
  isRedeemOnlyMember: boolean;
  loading: boolean;
  error: ApolloError;
} => {
  const { data, loading, error } = useQueryWithLog(
    logger,
    NERDWALLET_PLUS_MEMBERSHIP_QUERY,
    {
      skip: skipQuery,
    },
  );
  const isNerdWalletPlusMember = Boolean(
    data?.identity?.isNerdWalletPlusMember,
  );
  const isRedeemOnlyMember = Boolean(
    data?.identity?.roles?.includes(
      IdentityAcls.ROLES.NERDWALLET.NW_PLUS_REDEEM_ONLY_MEMBER,
    ),
  );
  return { isNerdWalletPlusMember, isRedeemOnlyMember, loading, error };
};

export const mockIsNerdWalletPlusMemberResponse = (
  isNerdWalletPlusMember: boolean,
): MockedResponse => ({
  request: {
    query: NERDWALLET_PLUS_MEMBERSHIP_QUERY,
  },
  result: {
    data: {
      identity: {
        id: 'test-identity-id',
        isNerdWalletPlusMember,
        roles: ['nw/bloop'],
      },
    },
  },
});
